<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_xiv"></a><a id="page_xv"></a><a id="map"></a><strong>MAPS</strong></p>
<p class="toc-a"><a href="#/html/9780226160702_12_map1#map1">1. Negro Population by Wards, Chicago, 1900</a></p>
<p class="toc-a"><a href="#/html/9780226160702_12_map1#map2">2. Negro Population by Wards, Chicago, 1910</a></p>
<p class="toc-a"><a href="#/html/9780226160702_12_map1#map3">3. Negro Population by Census Tracts, Chicago, 1910</a></p>
<p class="toc-a"><a href="#/html/9780226160702_12_map1#map4">4. Negro Population by Census Tracts, Chicago, 1920</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226160702_07_map.vue?c59338ac